import React from 'react';

import {Dialogue, Button, Anchor, Text} from '@albert-io/atomic';

interface Props {
  className: string;
  handleClose: () => void;
}

const RegistrationNotFound = ({className, handleClose}: Props) => (
  <Dialogue hideCloseBtn className={className} size='m' title='Missing information.'>
    <Dialogue.Body>
      <div className='u-display_flex u-flex-direction_column'>
        <Text>
          We&apos;re missing information from your LMS. This typically occurs when the integration
          hasn&apos;t been setup correctly. Please reach out to our support team through the chat
          widget below or by <Anchor href='mailto:success@albert.io'>email</Anchor>.
        </Text>
      </div>
    </Dialogue.Body>
    <Dialogue.BtnGroup>
      <Button onClick={() => handleClose()}>Dismiss</Button>
    </Dialogue.BtnGroup>
  </Dialogue>
);

export default RegistrationNotFound;
